// utils/authUtils.js
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const getToken = () => {
  return Cookies.get("authToken"); // or whatever your token cookie name is
};

export const getUserRoleFromToken = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.role; // assuming your JWT has a 'role' field
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};
